export default "__VITE_ASSET__Ma2jZFM___"